import React from "react"
import { useAppContext } from "../../AppContext";

export const globalFilterStatisticCard = (
    typeOptions,
    { title, cardClasses = "stats-cols-1", type = "toggle", showCount = true, userRoles, singleSelect, filters, user, handleParamsChange, getFilteredResults, onChange } = {}
  ) => {
    let params = { ...filters.params };

    return (
      <div className="modern-filter-card">
        {title && (
          <div className="modern-filter-card__header">
            <span className="modern-filter-card__accent" />
            <span className="modern-filter-card__title">{title}</span>
          </div>
        )}
        <div className={`modern-filter-card__grid ${cardClasses}`}>
          {typeOptions.map((opt) => {
            if (opt?.userRoles && !opt?.userRoles.includes(user?.role?.id)) return null;

            let found = opt?.multiSelect
              ? params[opt.key]?.some((optValue) => optValue == opt.value)
              : opt.value == params[opt.key];
            if (opt?.isBoolean) found = params[opt.key] == "true";

            const onChangeHandle = () => {
              if (opt.disabled) return;
              if (found) {
                let value = opt?.multiSelect
                  ? [...params[opt.key]].filter((val) => val !== opt.value)
                  : null;
                if (opt?.isBoolean) value = "false";
                handleParamsChange(null, opt.key, value);
                if (opt?.excludeIfNull) {
                  delete params[opt.key];
                  getFilteredResults({ data: { ...filters, params: { ...params } } });
                } else {
                  getFilteredResults({ data: { ...filters, params: { ...params, [opt.key]: value } } });
                }
              } else {
                let value = opt?.multiSelect
                  ? [...(params[opt.key] ? params[opt.key] : []), opt.value]
                  : opt.value;
                if (opt?.isBoolean) value = "true";
                handleParamsChange(null, opt.key, value);
                getFilteredResults({ data: { ...filters, params: { ...params, [opt.key]: value } } });
              }
            };

            return (
              <div
                key={opt.value + opt?.key}
                className={`modern-filter-item ${found ? 'modern-filter-item--active' : ''} ${opt?.disabled ? 'modern-filter-item--disabled' : ''}`}
                onClick={onChange ? () => onChange({ opt, found, params, singleSelect }) : onChangeHandle}
              >
                <div className="modern-filter-item__content">
                  {type === "checkbox" ? (
                    <div className="modern-checkbox">
                      <div className={`modern-checkbox__box ${found ? 'modern-checkbox__box--checked' : ''}`}>
                        {found && <svg viewBox="0 0 12 10" className="modern-checkbox__icon"><polyline points="1.5 6 4.5 9 10.5 1" /></svg>}
                      </div>
                      <span className="modern-checkbox__label">{opt.label}</span>
                    </div>
                  ) : (
                    <div className="modern-toggle">
                      <div className={`modern-toggle__track ${found ? 'modern-toggle__track--active' : ''}`}>
                        <div className="modern-toggle__thumb" />
                      </div>
                      <span className="modern-toggle__label">{opt.label}</span>
                    </div>
                  )}
                  {opt?.showCount === undefined && (
                    <span className={`modern-filter-item__badge ${found ? 'modern-filter-item__badge--active' : ''} ${opt?.roundPillStyle ?? ''}`}>
                      {opt?.count ?? 0}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
